import React from "react";
import clsx from "clsx";
import MenuItem from "../MenuItem";

import styles from "./Level2.styles";

const Level2 = ({ id, items }) => {
	const css = styles();

	return (
		<ul
			aria-labelledby={`submenu-trigger-${id}`}
			className={clsx(css.level2, "mco-view-component-header-menu-mobilemenu-level2")}
			id={`submenu-${id}`}
			role="menu"
		>
			{items?.map(item => {
				return (
					<li key={item?.id}>
						<MenuItem item={item} level={2} />
					</li>
				);
			})}
		</ul>
	);
};

export default Level2;
